import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Input } from "components";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import Footer from "components/Footer";
import globalRequest from "utils/global/globalRequest";
import * as API from "../../utils/helper/Enum";
import { changeLoader } from "redux/reducers/loader";
import * as CUSTOM from "../../utils/helper/custom";
import { useDispatch } from "react-redux";
import { setSnackbar } from "redux/reducers/snackbar";
import { DeleteModal } from "popups/DeleteModal";

const DeletePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [reason, setReason] = useState("");
  const dispatch = useDispatch();
  const [otherReason, setOtherReason] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  /**
   * delete custom cake
   */
  const deleteConfirm = async (type = "no") => {
    if (!confirmed) return;
    if (
      !reason ||
      (reason === "deleteReasonOthers" && otherReason.trim() === "")
    )
      return;
    let finalReason =
      reason === "deleteReasonOthers" ? otherReason.trim() : t(reason);
    if (type == "yes") {
      dispatch(changeLoader(true));
      try {
        let response = await globalRequest(
          API.USERS.DELETE_USER,
          "delete",
          { reason: finalReason },
          {},
          true
        );

        response = response?.data;
        if (response?.status == "SUCCESS") {
          setShowDeleteModal(false);
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "success",
            })
          );
          let language = localStorage.getItem("jsahdjkanbn");
          CUSTOM.clearLocalData();
          localStorage.setItem("jsahdjkanbn", language);
          //   closepopup(false);
          //   dispatch(changeTrigger("closepopup"));
          navigate("/login", { replace: true });
          window.location.reload();
        } else {
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "error",
            })
          );
        }
      } catch (e) {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: e?.message,
            snackbarState: "error",
          })
        );
      }
      dispatch(changeLoader(false));
    }
  };

  return (
    <>
      <div className="bg-gray-50_02 flex flex-col font-nunitoregular items-center justify-start mx-auto w-full h-full md:h-full">
        <div className="bg-white-A700 max-w-[1110px] flex flex-col items-start justify-start w-auto md:px-4 py-12 px-12 my-auto h-full rounded mt-12">
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            {t("deleteAccount")}
          </Typography>

          <Typography variant="body1" mb={2}>
            {t("deleteAccountDescription")}
          </Typography>

          <FormControl className="delete-form-control">
            <RadioGroup
              name="delete-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            >
              <FormControlLabel
                value="deleteReasonNotUseful"
                control={<Radio color="primary" />}
                label={t("deleteReasonNotUseful")}
              />
              <FormControlLabel
                value="deleteReasonPrivacy"
                control={<Radio color="primary" />}
                label={t("deleteReasonPrivacy")}
              />
              <FormControlLabel
                value="deleteReasonSwitchedPlatform"
                control={<Radio color="primary" />}
                label={t("deleteReasonSwitchedPlatform")}
              />
              <FormControlLabel
                value="deleteReasonOthers"
                control={<Radio color="primary" />}
                label={t("deleteReasonOthers")}
              />
            </RadioGroup>

            {reason === "deleteReasonOthers" && (
              <div className="mb-4">
                <Input
                  multiline
                  minRows={2}
                  className="w-full p-2 text-sm rounded-md text-white border border-gray-600 focus:border-red-500 focus:outline-none"
                  label={t("pleaseSpecifyYourReason")}
                  value={otherReason}
                  onChange={(e) => setOtherReason(e.target.value.slice(0, 250))}
                  maxLength={250}
                />
                <div className="text-right text-xs text-gray-400 mt-1">
                  {otherReason.length}/250
                </div>
              </div>
            )}
          </FormControl>
          <Box mt={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={confirmed}
                  onChange={(e) => setConfirmed(e.target.checked)}
                  color="error"
                />
              }
              label={t("confirmDelete")}
            />
          </Box>

          <Button
            className="common-pointer bg-black-900 hover:border hover:border-black-900 cursor-pointer font-nunitomedium h-12 mt-10 py-3.5 rounded text-base text-center text-white-A700 w-[180px] mb-5"
            hover={true}
            hoverclass="bg-white-A700"
            fullWidth
            sx={{ mt: 3 }}
            disabled={
              !confirmed ||
              !reason ||
              (reason === "deleteReasonOthers" && otherReason.trim() === "")
            }
            onClick={() => setShowDeleteModal(true)}
          >
            {t("deleteAccount")}
          </Button>
        </div>
        <Footer className="absolute bottom-[0] flex font-nunitoregular inset-x-[0] items-center justify-center mx-auto w-full" />
      </div>
      {!!showDeleteModal && (
        <DeleteModal
          type={"deleteAccount"}
          deleteTitle={t("deleteAccount")}
          deleteParagraph={t("areYouSureYouWantToDelete")}
          closepopup={setShowDeleteModal}
          deleteConfirm={deleteConfirm}
        />
      )}
    </>
  );
};

export default DeletePage;
